import { render, staticRenderFns } from "./impostosNfeSimples.vue?vue&type=template&id=aa51e7ae&scoped=true"
import script from "./impostosNfeSimples.vue?vue&type=script&lang=js"
export * from "./impostosNfeSimples.vue?vue&type=script&lang=js"
import style0 from "./impostosNfeSimples.vue?vue&type=style&index=0&id=aa51e7ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa51e7ae",
  null
  
)

export default component.exports